// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BarChartController from "./bar_chart_controller"
application.register("bar-chart", BarChartController)

import ComparisonChartController from "./comparison_chart_controller"
application.register("comparison-chart", ComparisonChartController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GroupedBarChartController from "./grouped_bar_chart_controller"
application.register("grouped-bar-chart", GroupedBarChartController)


import PieChartController from "./pie_chart_controller"
application.register("pie-chart", PieChartController)

import SpiComparisonChartController from "./spi_comparison_chart_controller"
application.register("spi-comparison-chart", SpiComparisonChartController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)
